import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import aboutus_1 from '../img/aboutus/aboutus-1.svg'
import aboutus_2 from '../img/aboutus/aboutus-2.svg'
import aboutus_3 from '../img/aboutus/aboutus-3.svg'
import aboutus_4 from '../img/aboutus/aboutus-4.svg'
import aboutus_5 from '../img/aboutus/aboutus-5.svg'

import aboutus_sample_1 from '../img/aboutus/aboutus_sample_1.png'
import aboutus_sample_2 from '../img/aboutus/aboutus_sample_2.png'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Aboutus extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);
	}

	render() {
		return (
			<div>
				<Helmet
					title="Find out more about our freelance academic writing agency - UvoCorp.com"
					meta={[
						{ name: "description", content: "Find out more about Uvocorp.com. Students, teachers, retired, and freelance writers can find a great academic writing job. Become a skilled writer." },

						{ property: 'og:title', content: "Find out more about our freelance academic writing agency - UvoCorp.com" },
						{ property: 'og:description', content: "Find out more about Uvocorp.com. Students, teachers, retired, and freelance writers can find a great academic writing job. Become a skilled writer." },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/about.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>
				<div className="wrapper">

					<div className="inner-header">
						<div className="container">
							<h1>About Us</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>

					<div className="inner-gray inner-center">
						<div className="container">
							<div className="col-sm-push-5 col-sm-7">
								<p><Link to="/">UVOCORP</Link> is an academic writing assistance company. We provide our help to the numerous clients looking for a professional writing service.</p>
								<p>Our company was founded in 2006, when academic writing organizations just started to emerge. Since that time, we have grown from a small startup into a considerable enterprise. Our care for writers, aspiration for constant perfection, and focus on developing trustworthy relations are what make UVOCORP the best workplace for freelance writers from all over the world.</p>
							</div>
							<div className="col-sm-pull-7 col-sm-5">
								<div className="aboutus_img aboutus_img_1">
									<img src={aboutus_1} alt="About Us Image1"/>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-white inner-center">
						<div className="container">
							<div className="col-sm-7">
								<p>Our company’s long-term goal is to become the quality standard in the market of custom academic writing services. In particular, we strive for:</p>
								<ul>
									<li>Development of high-quality products</li>
									<li>Writing authentic, non-plagiarized papers</li>
									<li>Timely delivery of customers’ orders</li>
									<li>Providing our writers with a variety of options for professional development</li>
									<li>Creating a positive public image.</li>
								</ul>
								<p>We seek to gain our writers’ support in achieving these goals through teamwork. We also aspire to maintain the win-win system of responsibilities between the company and the freelancers’ team. Such a close partnership helps UVOCORP maintain the top position among the world enterprises.</p>
								<p>Our company appreciates its employees and values our continued partnership through understanding and following the common principles of the company. Our progress is demonstrated through:</p>
								<ul>
									<li>Innovation</li>
									<li>Collaboration</li>
									<li>Mutual respect</li>
									<li>Development</li>
									<li>Quality.</li>
								</ul>
							
							</div>
							<div className="col-sm-5">
								<div className="aboutus_img aboutus_img_2">
									<img src={aboutus_2} alt="About Us Image2"/>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-gray inner-center inner-center-md">
						<div className="container">
							<div className="col-md-push-5 col-md-7">
								<h2 className="inner-left">What We Do</h2>
								<p>Our company offers a wide range of topics for writers. If you are an expert on the health industry or a history fan, you may enjoy writing articles or research papers on nursing or historical events. We deal with research papers, essays, creative writing, as well as dissertation chapters.</p>
								<p>As a newcomer, you may start exploring our writing platform by choosing short-term papers about the effects of global warming, political debates, the best types of leadership practices, mathematical projects, etc., moving slowly towards complicated assignments and research papers that require more effort but bring more remuneration as well.</p>
								<p>Freelance writing job is about discovering your strengths and talents and making them work with the customers’ demands. We will help you reveal your writing potential!</p>
							</div>
							<div className="col-md-pull-7 col-md-5">
								<div className="aboutus_img aboutus_img_3">
									<img src={aboutus_3} alt="About Us Image3"/>
								</div>
							</div>
						</div>
					</div>
					
					<div className="inner-white">
						<div className="container">
							<div className="col-md-6">
								<h2 className="inner-left">Common Assignments</h2>
								<p>A writer may expect to work on the following types of assignments:</p>
								<ul>
									<li>Essay</li>
									<li>Research Paper</li>
									<li>Presentation or Speech</li>
									<li>Case Study</li>
									<li>Creative Writing</li>
									<li>Book/Movie Review</li>
									<li>Annotated Bibliography</li>
								</ul>
							
								<p>In essence, each type of academic paper facilitates professional growth and ensures that writers always have a variety of assignments to choose from. Working with us is always full of opportunities and interesting projects!</p>
								<p>Each assignment has its own deadline, which ranges from below 7 hours to more than 9 days. We recommend that our new writers start with completing long-deadline orders. As you grow up as a professional, feel free to focus on more urgent orders.</p>
								<p>Most of the papers are to be formatted according to the guidelines established by the APA or the MLA.</p>
								<p>We provide a special guide on each formatting style, which eases the adaptation process of our freelancers.</p>
							
							</div>
							<div className="col-md-6">

								<div className="writingstyle">
									<input type="radio" id="style1" name="style" defaultChecked="checked" />
									<input type="radio" id="style2" name="style" />
									<label htmlFor="style1" className="writingstyle-tab writingstyle-tab-1"><strong>APA</strong> Style</label>
									<label htmlFor="style2" className="writingstyle-tab writingstyle-tab-2"><strong>MLA</strong> Style</label>

									<div className="writingstyle-content writingstyle-content-1">
										<div className="writingstyle-col-left">
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Style</div>
												<div className="writingstyle-info-text">APA</div>
											</div>
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Title</div>
												<div className="writingstyle-info-text">Varying Definitions of Online Communication and Their Effects on Relationship Research</div>
											</div>
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Academic level</div>
												<div className="writingstyle-info-text">Undergrad. (yrs 3-4)</div>
											</div>
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Format</div>
												<div className="writingstyle-info-text">Double spaced<br />12pt Times New Roman</div>
											</div>
										</div>
										<div className="writingstyle-col-right">
											<div className="writingstyle-preview">
												<img src={aboutus_sample_1} alt="About Us Sample 1"/>
											</div>
											<div className="writingstyle-button">
												<a target="_blank" href="https://owl.english.purdue.edu/owl/resource/560/01/">View sample</a>
											</div>
										</div>
									</div>

									<div className="writingstyle-content writingstyle-content-2">
										<div className="writingstyle-col-left">
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Style</div>
												<div className="writingstyle-info-text">MLA</div>
											</div>
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Title</div>
												<div className="writingstyle-info-text">Toward a Recovery of Nineteenth Century Farming Handbooks</div>
											</div>
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Academic level</div>
												<div className="writingstyle-info-text">Undergrad. (yrs 3-4)</div>
											</div>
											<div className="writingstyle-info-item">
												<div className="writingstyle-info-label">Format</div>
												<div className="writingstyle-info-text">Double spaced<br />12pt Times New Roman</div>
											</div>
										</div>
										<div className="writingstyle-col-right">
											<div className="writingstyle-preview">
												<img src={aboutus_sample_2} alt="About Us Sample 2"/>
											</div>
											<div className="writingstyle-button">
												<a target="_blank" href="https://owl.english.purdue.edu/owl/resource/747/01/">View sample</a>
											</div>											
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

					<div className="inner-gray inner-center">
						<div className="container">
							<div className="col-sm-push-5 col-sm-7">
								<h2 className="inner-left">Writer’s Responsibilities:</h2>

								<p>We expect our writers to fulfill the following responsibilities:</p>

								<ul>
									<li>carefully adhere to paper requirements, customer’s instructions, formatting guidelines, and citing rules;</li>
									<li>follow the correct sentence, paragraph, and the overall paper structure;</li>
									<li>develop a smooth flow of thoughts, achieving the coherency of ideas.</li>
								</ul>

								<p>Since the performance level of our writers directly affects our reputation and the number of repeat customers, we expect the timely delivery of plagiarism-free papers.</p>

							</div>
							<div className="col-sm-pull-7 col-sm-5">
								<div className="aboutus_img aboutus_img_4">
									<img src={aboutus_4} alt="About Us Image4"/>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-white">
						<div className="container">
							<div className="aboutus-disciplines">
								<h2 className="inner-left">Disciplines We Have</h2>
								<p className="aboutus-subtitle">Top disciplines</p>
								<ul className="col-sm-9">
									<li className="discipline_16">English 101</li>
									<li className="discipline_6">Business Studies</li>
									<li className="discipline_18">Management</li>

									<li className="discipline_17">History</li>
									<li className="discipline_19">Nursing</li>
									<li className="discipline_20">Psychology</li>

									<li className="discipline_21">Health Care</li>
									<li className="discipline_9">Economics</li>
									<li className="discipline_24">Education</li>

									<li className="discipline_22">Marketing</li>
									<li className="discipline_2">Communications</li>
									<li className="discipline_23">Political Science</li>

								</ul>
								<div className="aboutus_img aboutus_img_5">
									<img src={aboutus_5} alt="About Us Image5"/>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/about.html.js